import React, { useEffect, useState } from "react";
import HomeComponents from "./HomeComponents";

const Home = () => {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setIsLoading(false), 700);
    return () => clearTimeout(t);
  }, []);

  if (isLoading) {
    return (
      <div className="portfolio-loader">
        <span className="portfolio-loader__dot" aria-hidden />
        Loading
      </div>
    );
  }

  return <HomeComponents />;
};

export default Home;
